// extracted by css-extract-rspack-plugin
export default {"editorContainer":"t6Qd1","editor":"tNsMI","sidebar":"MitD0"};